<template>
  <div style="height: 100vh" class="flex flex-direction-column overflow">
    <div class="bg-black p20 featured-title">
      <!--<a href="index.html"><img src="assets/images/logo.png" alt=""></a>-->
      <h1 style="font-size: 36px;line-height: 45px;color: #ffffff;font-family:'Qanto'"><a href="http://www.dadazx.com" title="蛙游者官网" class="text-white">蛙游者</a></h1>
    </div>
    <div class="p20 flex flex-direction-column flex1 overflowY-hidden">
      <div>
        <a-tabs default-active-key="1" v-model="tab">
          <a-tab-pane :key="1" tab="幻兽帕鲁" />
          <a-tab-pane :key="2" tab="僵尸毁灭工程地图" />
        <!--<a-tab-pane key="1" tab="Tab 1" />-->
        </a-tabs>
      </div>
      <div v-show="tab === 1" class="pr overflowY-hidden flex1">
        <div class="overflowX-auto hper">
          <a-form-data class="w800" ref="form" v-model="form" :setting="setting" :render-data="renderData" />
        </div>
        <a-button class="pa top0" style="left: 830px" type="primary" :loading="loading" @click="download">下载配置文件</a-button>
      </div>
      <div v-show="tab === 2" class="bg-black flex1">
        <iframe src="http://node.dyboke.cn/" class="wper hper" style="border: none"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'pal',
    data() {
      return {
        tab: 1,
        loading: false,
        form: {
          "ServerName": '蛙游者',
          "ServerPlayerMaxNum": 6,
          "ServerPassword": '',
          "PublicPort": 8211,
          "PublicIP": '""',
          DayTimeSpeedRate: 1.0,
          NightTimeSpeedRate: 1.0,
          ExpRate: 1.0,
          /* 帕鲁 */
          PalCaptureRate: 1.0,
          PalSpawnNumRate: 1.0,
          PalDamageRateAttack: 1.0,
          PalDamageRateDefense: 1.0,
          PalStomachDecreaceRate: 1.0,
          PalStaminaDecreaceRate: 1.0,
          PalAutoHPRegeneRate: 1.0,
          PalAutoHpRegeneRateInSleep: 1.0,
          WorkSpeedRate: 1.0,
          /* 玩家 */
          PlayerDamageRateAttack: 1.0,
          PlayerDamageRateDefense: 1.0,
          PlayerStomachDecreaceRate: 1.0,
          PlayerStaminaDecreaceRate: 1.0,
          PlayerAutoHPRegeneRate: 1.0,
          PlayerAutoHpRegeneRateInSleep: 1.0,
          BuildObjectDamageRate: 1.0,
          BuildObjectDeteriorationDamageRate: 1.0,
          /* 其他 */
          DropItemMaxNum: 3000,
          CollectionDropRate: 1.0,
          CollectionObjectHpRate: 1.0,
          CollectionObjectRespawnSpeedRate: 1.0,
          EnemyDropItemRate: 1.0,
          ItemWeightRate: 1.0,

          EquipmentDurabilityDamageRate: 1.0,
          SupplyDropSpan: 180,
          PalEggDefaultHatchingTime: 2.0,
          bEnableInvaderEnemy: 'False',
          DeathPenalty: 'None',
          BaseCampMaxNumInGuild: 5,
          BaseCampWorkerMaxNum: 15,
          bEnableFastTravel: 'True',

          /* 服务器 信息 */
          "CoopPlayerMaxNum": 20,
          "ServerDescription": '""',
          "AdminPassword": '"952700"',
          /* 默认配置 */
          "Difficulty": "None",
          "RandomizerType": "None",
          "RandomizerSeed": '""',
          "bIsRandomizerPalLevelRandom": "False",
          "BuildObjectHpRate": 5,
          "bEnablePlayerToPlayerDamage": "False",
          "bEnableFriendlyFire": "False",
          "bActiveUNKO": "False",
          "bEnableAimAssistPad": "True",
          "bEnableAimAssistKeyboard": "False",
          "DropItemMaxNum_UNKO": 100,
          "BaseCampMaxNum": 128,
          "DropItemAliveMaxHours": 1,
          "bAutoResetGuildNoOnlinePlayers": "False",
          "AutoResetGuildTimeNoOnlinePlayers": 72,
          "GuildPlayerMaxNum": 20,
          "AutoSaveSpan": 30,
          "bIsMultiplay": "False",
          "bIsPvP": "False",
          "bHardcore": "False",
          "bPalLost": "False",
          "bCharacterRecreateInHardcore": "False",
          "bCanPickupOtherGuildDeathPenaltyDrop": "False",
          "bEnableNonLoginPenalty": "True",
          "bIsStartLocationSelectByMap": "True",
          "bExistPlayerAfterLogout": "False",
          "bEnableDefenseOtherGuildPlayer": "False",
          "bInvisibleOtherGuildBaseCampAreaFX": "False",
          "bBuildAreaLimit": "False",
          "RCONEnabled": "False",
          "RCONPort": 25575,
          "Region": '""',
          "bUseAuth": "True",
          "BanListURL": '"https://api.palworldgame.com/api/banlist.txt"',
          "RESTAPIEnabled": "False",
          "RESTAPIPort": 8212,
          "bShowPlayerList": "False",
          "ChatPostLimitPerMinute": 100,
          "CrossplayPlatforms": "(Steam,Xbox,PS5,Mac)",
          "bIsUseBackupSaveData": "True",
          "LogFormatType": "Text",
          "EnablePredatorBossPal": "True",
          "MaxBuildingLimitNum": 0,
          "ServerReplicatePawnCullDistance": 15000,
          "bAllowGlobalPalboxExport": "True",
          "bAllowGlobalPalboxImport": "True",
        },

        setting: {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
          rules: {
            ServerName: [{ required: true, message: '请输入服务器名称', trigger: 'change' }],
            ServerPassword: [{ required: true, message: '请输入服务器密码', trigger: 'change' }],
            select: [
              { required: true, message: '请选择', trigger: 'change' }
            ],
          }
        },
        renderData: {
          ServerName: {
            label: '服务器名称',
            valid: true
          },
          ServerPassword: {
            label: '服务器密码',
            valid: true,
            renderName: 'aInputPassword',
            props: { type: 'password', maxLength: 6 }
          },
          DayTimeSpeedRate: {
            label: '白天流逝速度',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          NightTimeSpeedRate: {
            label: '夜晚流逝速度',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          ExpRate: {
            label: '经验值倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 20, step: 0.1 }
          },
          PalCaptureRate: {
            label: '捕获概率倍率',
            renderName: 'aSlider',
            props: { min: 0.5, max: 2, step: 0.1 }
          },
          PalSpawnNumRate: {
            label: '帕鲁出现倍率',
            renderName: 'aSlider',
            props: { min: 0.5, max: 3, step: 0.1 }
          },
          PalDamageRateAttack: {
            label: '帕鲁攻击伤害倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PalDamageRateDefense: {
            label: '帕鲁承受伤害倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PalStomachDecreaceRate: {
            label: '帕鲁饱腹度降低倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PalStaminaDecreaceRate: {
            label: '帕鲁耐力降低倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PalAutoHPRegeneRate: {
            label: '帕鲁生命值自然回复倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PalAutoHpRegeneRateInSleep: {
            label: '帕鲁睡觉生命值回复倍率（终端）',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          WorkSpeedRate: {
            label: '帕鲁工作效率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerDamageRateAttack: {
            label: '玩家攻击伤害倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerDamageRateDefense: {
            label: '玩家承受伤害倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerStomachDecreaceRate: {
            label: '玩家饱腹度降低倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerStaminaDecreaceRate: {
            label: '玩家耐力降低倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerAutoHPRegeneRate: {
            label: '玩家生命值自然回复倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          PlayerAutoHpRegeneRateInSleep: {
            label: '玩家睡眠生命值回复倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 5, step: 0.1 }
          },
          BuildObjectDamageRate: {
            label: '对建筑伤害倍率',
            renderName: 'aSlider',
            props: { min: 0, max: 5, step: 0.1 }
          },
          BuildObjectDeteriorationDamageRate: {
            label: '建筑物劣化速度倍率',
            renderName: 'aSlider',
            props: { min: 0, max: 5, step: 0.1 }
          },
          DropItemMaxNum: {
            label: '世界掉落物上限',
            renderName: 'aSlider',
            props: { min: 1, max: 5000, step: 1, precision: 0 }
          },
          CollectionDropRate: {
            label: '道具采集量倍率',
            renderName: 'aSlider',
            props: { min: 0.5, max: 3, step: 0.1 }
          },
          CollectionObjectHpRate: {
            label: '可采集物品生命值倍率',
            renderName: 'aSlider',
            props: { min: 0.5, max: 3, step: 0.1 }
          },
          CollectionObjectRespawnSpeedRate: {
            label: '可采集物品刷新间隔',
            renderName: 'aSlider',
            props: { min: 0.5, max: 3, step: 0.1 }
          },
          EnemyDropItemRate: {
            label: '道具掉落量倍率',
            renderName: 'aSlider',
            props: { min: 0.5, max: 3, step: 0.1 }
          },
          ItemWeightRate: {
            label: '物品重量倍率',
            renderName: 'aSlider',
            props: { min: 0.1, max: 10, step: 0.1 }
          },
          EquipmentDurabilityDamageRate: {
            label: '装备耐久度降低倍率',
            renderName: 'aSlider',
            props: { min: 0, max: 5, step: 0.1 }
          },
          SupplyDropSpan: {
            label: '陨石·补给物资空投间隔（分）',
            renderName: 'aSlider',
            props: { min: 1, max: 999, step: 1, precision: 0 }
          },
          PalEggDefaultHatchingTime: {
            label: '巨大蛋孵化时间（小时）',
            renderName: 'aSlider',
            props: { min: 0, max: 240, step: 1, precision: 0 }
          },
          bEnableInvaderEnemy: {
            label: '是否发生袭击事件',
            renderName: 'aRadioGroup',
            options: [
              { label: '开', value: 'True' },
              { label: '关', value: 'False' }
            ]
          },
          DeathPenalty: {
            label: '死亡惩罚',
            renderName: 'aRadioGroup',
            options: [
              { label: '无掉落', value: 'None' },
              { label: '掉落除装备外的所有物品', value: 'Item' },
              { label: '掉落所有物品', value: 'ItemAndEquipment' },
              { label: '掉落所有物品和队伍中的所有帕鲁', value: 'All' },
            ]
          },
          BaseCampMaxNumInGuild: {
            label: '各个公会最大据点',
            renderName: 'aSlider',
            props: { min: 3, max: 7, step: 1, precision: 0 }
          },
          BaseCampWorkerMaxNum: {
            label: '据点工作帕鲁最大数',
            renderName: 'aSlider',
            props: { min: 1, max: 30, step: 1, precision: 0 }
          },
          RandomizerType: {
            label: '随机帕鲁',
            renderName: 'aRadioGroup',
            options: [
              { label: '无', value: 'None' },
              { label: '区域随机', value: 'Region' }
            ]
          },
          bIsRandomizerPalLevelRandom: {
            label: '随机帕鲁等级',
            renderName: 'aRadioGroup',
            options: [
              { label: '开', value: 'True' },
              { label: '关', value: 'False' }
            ]
          },
          bEnableFastTravel: {
            label: '是否启用快速传送',
            renderName: 'aRadioGroup',
            options: [
              { label: '开', value: 'True' },
              { label: '关', value: 'False' }
            ]
          },
          bIsPvP: {
            label: '是否启用PVP',
            renderName: 'aRadioGroup',
            options: [
              { label: '开', value: 'True' },
              { label: '关', value: 'False' }
            ],
            events: { change: this.changeBIsPvP }
          },
        }
      }
    },
    mounted() {
      if (this.$cookies.get('config')) {
        this.form = JSON.parse(this.$cookies.get('config'))
      }
    },
    methods: {
      changeBIsPvP() {
        this.form.bEnablePlayerToPlayerDamage = this.form.bIsPvP
        this.form.bEnableDefenseOtherGuildPlayer = this.form.bIsPvP
      },
      async download() {
        try {
          this.loading = true
          await this.$refs.form.formRef().validate()
          this.$cookies.set(JSON.stringify(this.form),'config')
          let str = '[/Script/Pal.PalGameWorldSettings]\n' +
              'OptionSettings=('
          for (let i in this.form) {
            if (i === 'ServerName') {
              str += `${i}="${this.form[i]}",`
            } else if (i === 'ServerPassword') {
              str += `${i}="${this.form[i]}",`
            } else {
              str += `${i}=${this.form[i]},`
            }
          }
          str = str.substring(0, str.length - 1)
          str += ')'
          let a = document.createElement('a')
          a.download = 'PalWorldSettings.txt'
          a.href = `data:ini/plain;charset=utf-8,${str}`
          a.rel = `noreferrer`
          a.click();
        } finally {
          this.loading = false
        }
      },
    }
  }
</script>


